const getConfig = () => {
  return {
    rowSelection: false,
    scroll: { y: `calc(100vh - 280px)` },
    columns: [
      {
        title: '通项名称',
        dataIndex: 'generalName',
        width: 160,
        ellipsis: true,
      },
      {
        title: '标配SKU名称',
        dataIndex: 'skuName',
        width: 160,
        ellipsis: true,
      },
      {
        title: '标配SKU_ID',
        dataIndex: 'skuId',
        width: 180,
      },
      {
        title: '适用产品',
        dataIndex: 'productName',
        width: 160,
        ellipsis: true,
      },
      {
        title: '适用门店',
        dataIndex: 'shopName',
        width: 160,
        ellipsis: true,
        render: (v, record) => record.shopId === '0' ? '通用' : v
      },
      {
        title: '标配SKU成本价',
        dataIndex: 'costPrice',
        width: 125,
        render: (v) => <div style={{textAlign: 'right'}}>{v?.toLocaleString?.()}</div>,
      },
      {
        title: '通项项目经理价',
        dataIndex: 'projectManagerPrice',
        width: 125,
        render: (v) => <div style={{textAlign: 'right'}}>{v?.toLocaleString?.()}</div>,
      },
      {
        title: '成本差(元)',
        dataIndex: 'costDifference',
        width: 95,
        fixed: 'right',
        render: 'costDifferenceRender'
      },
      {
        title: '成本差比率(%)',
        dataIndex: 'costDifferenceRate',
        width: 120,
        fixed: 'right',
        render: 'textRender'
      },
      {
        title: '预警类型',
        dataIndex: 'alertType',
        width: 100,
        fixed: 'right',
        render: 'typeRender'
      },
      {
        title: '操作',
        dataIndex: '#',
        width: 100,
        fixed: 'right',
        render: 'actionRender'
      },
    ],
    search: [
      {
        label: '适用产品',
        name: 'productId',
        itemType: 'custom',
        render: 'searchSelectRender'
      },
      {
        name: 'shopId',
        label: '适用门店',
        itemType: 'select',
        data: 'companyList',
        labelKey: 'name',
        key: 'id',
      },
      {
        name: 'generalId',
        label: '通项',
        itemType: 'custom',
        render: 'generalRender',
      },
      {
        label: '标配SKU名称/ID',
        name: 'skuKey'
      },
      {
        label: '预警类型',
        name: 'alertType',
        itemType: 'select',
        data: 'alertTypeEnum',
        key: 'key',
        labelKey: 'description'
      },
      {
        label: '差价范围(元)',
        name: 'costDifference',
        itemType: 'custom',
        render: 'rangeRender',
      },
      {
        label: '差价最小',
        name: 'costDifferenceMin',
        hidden: true,
      },
      {
        label: '差价最大',
        name: 'costDifferenceMax',
        hidden: true,
      },
      {
        label: '成本差比率范围',
        name: 'costDifferenceRate',
        itemType: 'custom',
        render: 'rangeRender',
      },
      {
        label: '成本差比率最小',
        name: 'costDifferenceRateMin',
        hidden: true,
      },
      {
        label: '成本差比率最大',
        name: 'costDifferenceRateMax',
        hidden: true,
      },
    ],
    footer: [
      {
        label: '导出',
        itemType: 'custom',
        render: 'exportRender'
      },
      {
        label: '查看配置',
        events: ['onClick:onAdd']
      },
    ],
  }
}

export {getConfig}